// extracted by mini-css-extract-plugin
module.exports = {"donutLabels":"Charts_donutLabels__wZ7Mz","label":"Charts_label__RQcFo"};